export const SocialProof = () => (
  null
);
